var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c(
            "div",
            { staticClass: "form-inline" },
            [
              _c("input-field", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.editable,
                    expression: "editable"
                  }
                ],
                attrs: {
                  placeholder: "Cód. Movimiento",
                  id: "referencia_movimiento"
                },
                model: {
                  value: _vm.referencia_movimiento,
                  callback: function($$v) {
                    _vm.referencia_movimiento = $$v
                  },
                  expression: "referencia_movimiento"
                }
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.editable,
                      expression: "editable"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  on: { click: _vm.consultarMovimiento }
                },
                [_c("i", { staticClass: "fa fa-download" })]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.movimientos, function(movimiento, index) {
                return _c("tr", { key: movimiento.id }, [
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(movimiento.referencia_movimiento) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(movimiento.cantidad_items) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(movimiento.created_at) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-info btn--text",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.verItems(movimiento)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-eye" })]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editable,
                            expression: "editable"
                          }
                        ],
                        staticClass: "btn-danger btn--text",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.quitarMovimiento(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-times" })]
                    )
                  ])
                ])
              }),
              _vm._v(" "),
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.movimientos.length === 0,
                      expression: "movimientos.length === 0"
                    }
                  ]
                },
                [_vm._m(2)]
              )
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            adaptive: "",
            reset: "",
            resizable: "",
            scrollable: "",
            name: "aceptarItemsAdicionales",
            height: "auto",
            width: "65%"
          }
        },
        [
          _c("aceptar-items-adicionales", {
            attrs: { items: _vm.itemsActuales },
            on: {
              aceptar: _vm.aceptarItems,
              cancelar: function($event) {
                return _vm.$modal.hide("aceptarItemsAdicionales")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            adaptive: "",
            reset: "",
            resizable: "",
            scrollable: "",
            name: "visorItemsAdicionales",
            height: "auto",
            width: "65%"
          }
        },
        [
          _c("visor-items-adicionales", {
            attrs: { items: _vm.itemsConsultados },
            on: {
              cerrar: function($event) {
                return _vm.$modal.hide("visorItemsAdicionales")
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h5", [_vm._v("Ítems adicionales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Movimiento")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cant. Ítems")]),
        _vm._v(" "),
        _c("th", [_vm._v("Fecha de asignación")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "4" } }, [
      _c("strong", [_vm._v("No ha agregado movimientos adicionales.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-731a532a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-731a532a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ItemsAdicionales.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-731a532a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/ItemsAdicionales.vue
// module chunks = 0